

import React from 'react';
import { COLORS, FONTS } from '@bcm/constants';
import { View, Text, StyleSheet} from 'react-native';

const Transition = ({ text }) => (
	<View style={styles.container}>
		<Text style={styles.text}>{text}</Text>
	</View>
);

const styles = StyleSheet.create({
	container: {
		height: '15vh',
		minHeight: 70,
		width: '100%',
		backgroundColor: COLORS.light,
		justifyContent: 'center',
		alignItems: 'center',
	},
	text: {
		fontFamily: FONTS.bold,
		fontSize: 40,
		color: COLORS.dark,
	},
});

export default Transition;